/**
 * 工具类
 */
// eslint-disable-next-line
import Vue from 'vue'
import CryptoJS from 'crypto-js'
export default {
  // 加密
  encrypt (key, word) {
    var _word = CryptoJS.enc.Utf8.parse(word)
    var _key = CryptoJS.enc.Utf8.parse(key)
    var encrypted = CryptoJS.AES.encrypt(_word, _key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    })
    return encrypted.toString()
  },
  // 解密
  decrypt (key, word) {
    var _key = CryptoJS.enc.Utf8.parse(key)
    var decrypt = CryptoJS.AES.decrypt(word, _key, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    })
    return CryptoJS.enc.Utf8.stringify(decrypt).toString()
  },

  // 3DES加密
  desEncrypt (key, word) {
    var _word = CryptoJS.enc.Utf8.parse(word)
    var keyHex = CryptoJS.enc.Utf8.parse(key)
    var encrypted = CryptoJS.TripleDES.encrypt(_word, keyHex, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    })
    return encrypted.toString()
  }
}
